module.exports = __webpack_public_path__ + "img/Plugeth_svg_s6flfr.b43f90ff.svg";